<router-view v-if="!isAppLoading"></router-view>
<loading v-model:active="isAppLoading" :can-cancel="false" :is-full-page="true"  loader="bars"/>
<p-toast position="bottom-right"></p-toast>
<p-confirm-dialog />

<div class="layout-wrapper " :class="containerClass">
    <!--header------------------------------------
    <MenuBar :app_base_data="app_base_data" :menu_items="getMenus" ></MenuBar>
    --header------------------------------------>

    
    <!--main--------------------------------------layout-main-container-->
    <div class="">
        
        <!--
        <app-bottom-menu v-if="isMobile && getMenus.length > 0" :app_base_data="app_base_data" :menu_items="getMenus" ></app-bottom-menu>
        -->
    </div>
    <!--main-------------------------------------->
    
</div>
